import { useReducer, useCallback } from "react";

const initialState = {
    loading: false,
    done: false,
    data: null,
    error: null
}

const useDataApi = (promise) => {
    const reducer = (state, action) => {
        switch (action?.type) {
            case "FETCH_INIT":
                return {
                    loading: true,
                    done: false,
                    data: null,
                    error: null
                }
            case "FETCH_SUCCESS":
                return {
                    loading: false,
                    done: true,
                    data: action?.payload,
                    error: null
                }
            case "FETCH_FAILURE":
                return {
                    loading: false,
                    done: true,
                    data: null,
                    error: action?.payload
                }
            case "RESET":
                return initialState
            default:
                return state
        }
    }
    const [state, dispatch] = useReducer(reducer, initialState);

    const useFetch = (async (...args) => {
        const fetchData = async () => {
            dispatch({ type: "FETCH_INIT" });
            try {
                const result = await promise?.(...args);
                dispatch({ type: "FETCH_SUCCESS", payload: result?.data });
                return result?.data;
            } catch (error) {
                dispatch({ type: "FETCH_FAILURE", payload: error });
                return error;
            }
        };
        return await fetchData();
    });

    function fnReset() {
        dispatch({ type: "RESET" })
    }

    return [state, useFetch, fnReset];
};

export default useDataApi;